var _style, _g, _path, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcServiceManager(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214,234.3H35.4V16.6l139-0.7l39.6,41V234.3z M40.5,229.2h168.4V58.9L172.2,21L40.5,21.6V229.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.8,215.8H85.4V102.4h113.4V215.8z M90.5,210.7h103.3V107.4H90.5V210.7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 110.6,
    y: 137.7,
    className: "st0",
    width: 26.2,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.1,
    y: 127.1,
    className: "st0",
    width: 5.1,
    height: 26.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 162.3,
    y: 126.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -51.1212 157.7261)",
    className: "st0",
    width: 5.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.8,
    y: 138,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -51.1212 157.7261)",
    className: "st0",
    width: 28.1,
    height: 5.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 109.4,
    y: 179,
    className: "st0",
    width: 26.2,
    height: 5.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 170.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.5,175.3c-1.2,0-2.3-0.5-3.2-1.3c-1.7-1.7-1.7-4.6,0-6.3c0.8-0.8,2-1.3,3.2-1.3h0c1.2,0,2.3,0.5,3.2,1.3 c1.7,1.7,1.7,4.6,0,6.3l0,0C124.8,174.8,123.7,175.3,122.5,175.3L122.5,175.3z M122.2,170.5c-0.2,0.2-0.2,0.5,0,0.6h0.6 c0.2-0.2,0.2-0.5,0-0.6H122.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 192.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.5,196.8c-1.2,0-2.3-0.5-3.2-1.3c-1.7-1.7-1.7-4.6,0-6.3c1.7-1.7,4.6-1.7,6.3,0c1.7,1.7,1.7,4.6,0,6.3 C124.8,196.3,123.7,196.8,122.5,196.8L122.5,196.8z M122.5,191.9c-0.1,0-0.2,0-0.3,0.1c-0.2,0.2-0.2,0.5,0,0.6h0.6 c0.2-0.2,0.2-0.5,0-0.6C122.7,191.9,122.6,191.9,122.5,191.9z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 151.7,
    y: 179.1,
    className: "st0",
    width: 26.2,
    height: 5.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.2,91.9v-4.8c-7-0.8-11.4-5.3-12.5-11.5l5-2.6c0.8,5.1,3.3,8.1,7.5,9V69.6c-6.6-1.5-10.8-5.2-10.8-10.8 c0-2.6,1-4.9,3-6.7c2-1.7,4.5-2.8,7.8-3.1v-4.6h4.7v4.8c5.4,0.8,9.1,3.8,10.9,9l-4.5,2.6c-1.2-3.6-3.4-5.8-6.4-6.7v11.4 c7.9,1.5,11.6,4.8,11.6,10.8c0,2.8-1.1,5.3-3.1,7.3c-2.1,2.1-4.9,3.3-8.5,3.7v4.6H78.2z M78.2,64.2V54c-3.2,0.5-5.4,2.2-5.4,4.7 C72.8,61.1,74.6,62.9,78.2,64.2z M82.9,70.6v11.6c3.6-0.6,5.9-2.9,5.9-5.8C88.8,73.4,86.9,71.7,82.9,70.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcServiceManager);
export default __webpack_public_path__ + "static/media/ic-service-manager.71220248274feb1179aff463e913e166.svg";
export { ForwardRef as ReactComponent };